module.exports = __webpack_public_path__ + "img/medal_green.8fa6c0e3.svg";